/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-nested-ternary */
import { useEffect, useState } from "react";
import DownArrowIcon from "assets/svgs/DownArrowIcon";
import UpArrowIcon from "assets/svgs/UpArrowIcon";
import { trackOnMixpanel } from "modules/candidate/profile/utils/MixpanelHelper";
import styled from "styled-components";
import { JobDescriptionProps } from "../types";
import {
	ReadDescriptionButton,
	DescriptionText,
	DescriptionTextFull,
	ButtonContainer,
} from "./styles";

const JobDescription: React.FC<JobDescriptionProps> = ({
	jobDescription,
	shortJobDescription,
	jobDetail,
}) => {
	const [showJobDescription, setShowJobDescription] = useState(true);
	useEffect(() => {
		setTimeout(() => {
			setShowJobDescription(false);
		}, 50);

		trackOnMixpanel("Show more job description seen web", {
			"Job Board Type": jobDetail?.is_external_job ? "Non Apna Job" : "Apna Job",
			"Company Name": jobDetail?.organization?.name,
			"Job ID": jobDetail?.id,
			"Job Title": jobDetail?.title,
			Source: "Job Details Page Web",
		});
	}, []);

	const [scrollPosition, setScrollPosition] = useState(0);
	const handleButtonClick = () => {
		trackOnMixpanel("Show more job description clicked web", {
			"Job Board Type": jobDetail?.is_external_job ? "Non Apna Job" : "Apna Job",
			"Company Name": jobDetail?.organization?.name,
			"Job ID": jobDetail?.id,
			"Job Title": jobDetail?.title,
			Source: "Job Details Page Web",
		});
		setShowJobDescription(!showJobDescription);
		setScrollPosition(window.scrollY);
		showJobDescription ? window.scrollTo(0, scrollPosition) : window.scrollY;
	};
	if (!jobDetail?.rich_description) {
		return null;
	}
	return (
		<div>
			<div className="md:mt-[24px]">
				<p className="mb-[16px] bg-white text-md font-semibold md:mb-[12px]">
					Job Description
				</p>
				{!showJobDescription && (
					<DescriptionText
						dangerouslySetInnerHTML={{
							__html: shortJobDescription,
						}}
						showBlendElement={shortJobDescription?.length > 300}
					/>
				)}
				<DescriptionTextFull
					dangerouslySetInnerHTML={{
						__html: jobDescription,
					}}
					showJobDescription={showJobDescription}
				/>
			</div>
			{jobDescription?.length > 300 && (
				<ButtonC onClick={handleButtonClick}>
					<ReadDescriptionButton>
						<span>{showJobDescription ? "Show less" : "Show more"}</span>
						{showJobDescription ? (
							<UpArrowIcon fill="#1F8268" height="16" width="16" />
						) : (
							<DownArrowIcon fill="#1F8268" height="10" width="10" />
						)}
					</ReadDescriptionButton>
				</ButtonC>
			)}
		</div>
	);
};

export default JobDescription;

const ButtonC = styled.div`
	border: 1px solid transparent;
	margin-left: auto;
	width: max-content;
`;
